import React from "react";
import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";

import { CatalogStore, ConfigurationStore } from "stores";
interface IHeader {
  id: string;
}

const Header: React.FC<IHeader> = ({ id }): JSX.Element | null => {
  const configuration = React.useContext(ConfigurationStore);
  const { formatMessage: t } = useIntl();

  const {
    state: { entities },
  } = React.useContext(CatalogStore);
  const href = window.location.href;

  if (!(entities.modell_gruppe && entities.marke)) return null;

  const modellGruppe = entities.modell_gruppe[id];
  if (!modellGruppe) return null;
  const marke = entities.marke[modellGruppe.marke];
  if (!marke) return null;

  const title = configuration.application.title || "carbando catalog";

  return (
    <>
      <h1 className="aria-hidden">
        {t(
          {
            id: "pages.modell.title",
            defaultMessage:
              "Gruppierte Übersicht der verfügbaren Modelle der Modellgruppe {marke} {modellGruppe}",
          },
          { marke: marke.name, modellGruppe: modellGruppe.name },
        )}
      </h1>
      <Helmet>
        {configuration.application.inline === false && (
          <>
            <title>{`${title} - ${modellGruppe.name}`}</title>
            <meta
              property="og:title"
              content={`${title} - ${modellGruppe.name}`}
            />
            <meta property="og:url" content={href} />
            <meta property="og:type" content="article" />
            <meta property="og:site_name" content={title} />
          </>
        )}
      </Helmet>
    </>
  );
};

export default Header;
